import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import '@fontsource/space-grotesk/400'
import '@fontsource/space-grotesk/500'
import '@fontsource/space-grotesk/700'
import '@fontsource/sora/400'
import '@fontsource/sora/600'
import '@fontsource/sora/700'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
) 